<template>
  <div>
    <v-card>
      <v-card-title>
        <h1>Select Tests</h1>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selectedTests"
          :headers="headers"
          :items="tests"
          :items-per-page="10"
          :loading="testsLoading"
          item-key="vesselMachineTestId"
          show-select
        ></v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import Objects from '@/services/Objects'

export default {
  name: 'VesselTrialTestSelectTable',
  props: {
    id: String
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Number', value: 'order' },
        { text: 'Method', value: 'method' }
      ],
      tests: [],
      selectedTests: [],
      unselectedTests: [],
      loading: false,
      testsLoading: false
    }
  },
  created() {
    this.getTests()
  },
  methods: {
    getTests() {
      ApiService.get(Objects.VesselMachineTest + '/byvessel', this.id).then(
        response => {
          this.tests = response.data
        }
      )
    },
    getSelectedTests() {
      const testIds = []

      for (var test of this.selectedTests) {
        testIds.push(test.vesselMachineTestId)
      }
      return testIds
    }
  }
}
</script>

<style scoped></style>
